import React from 'react';
import { motion } from 'framer-motion';
import { HashLink as Link } from 'react-router-hash-link';
import bgVideo from '../assets/medical.mp4';

const Hero = () => {
  return (
    <motion.div
      className="hero-section relative text-white"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.2 }}
    >
      {/* Background Video */}
      <video
        src={bgVideo}
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      />

      {/* Overlay */}
      <div className="overlay absolute z-10"></div>

      {/* Content */}
      <div className="content z-20 max-w-[800px] w-full mx-auto text-center px-4">
        <h1 className="md:text-5xl sm:text-5xl text-4xl font-medium md:py-6">
          Empowering Clinical Teams with <br/>AI-Powered Insights
        </h1>
        <div>
          <p className="md:text-xl sm:text-lg text-md">
            Cura AI streamlines intake, triage, and <br /> documentation so clinicians can focus on care
          </p>
        </div>

        <div className="flex justify-center gap-4 mt-6 flex-wrap">
          <Link
            smooth
            to="/#pricing"
            className="bg-[#427cfc] rounded-3xl font-medium px-6 py-3 text-white hover:scale-105 transition duration-200"
          >
            Request a Consultation
          </Link>

          <Link
            smooth
            to="/#pricing"
            className="bg-transparent border border-white rounded-3xl font-medium cursor-pointer px-6 py-3 text-white hover:bg-white hover:text-black hover:scale-105 transition duration-200"
          >
            Join Our Pilot
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default Hero;